import { sendMessage } from './messages-fire'
import { getConversation } from '../../Conversations/middleware/conversation-fire'

const conversationMiddleware = store => next => action => {

  switch (action.type) {
    case "getConversation": {
      var {conversationUid} = action

      next(action)

      return getConversation(conversationUid, next)
    }
    case "sendMessage": {
      var {conversationUid, messageData} = action
      next(action)

      return sendMessage(conversationUid, messageData, next)
    }
    default:
      return next(action)
  }

}

export default conversationMiddleware;


// WEBPACK FOOTER //
// ./src/Components/MessagingScreen/middleware/index.js